<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 text-xs-center>
        <v-img :src="require('../assets/hp-logo.gif')" class="my-3" contain height="200"></v-img>
      </v-flex>

      <v-flex xs12 text-xs-center>
        <h1 class="display-2 font-weight-bold mb-3" align="center">Thank you!</h1>
        <p class="subheading font-weight-regular" align="center">
          We really appreciate your feedback.
          <br />To find out more about Healthy Performance, please click
          <b>
            <a href="https://www.healthyperformance.co.uk" target="_blank">here</a>
          </b>
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FullPageLayout from "../layouts/FullPageLayout";
export default {
  created() {
    this.$emit(`update:layout`, FullPageLayout);
    // this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>
